export type Tome = {
  label: string;
  title: string;
  subtitle: string;
  cover: string;
  coverAlt: string;
  features: string[];
};

export type Bonus = {
  number: string;
  title: string;
  pages: string;
  cover: string;
};

export const tomes: Tome[] = [
  {
    label: 'TOMO I',
    title: 'El Manual de Intervención de Campo',
    subtitle: 'Protocolos de respuesta inmediata para crisis en consulta',
    cover: 'https://cdn.magicpatterns.com/uploads/q6pY1UV2hYLprCZ51C6um3/pasted-image.png',
    coverAlt: 'Portada del Tomo I: El Manual de Intervención de Campo, Botiquín Bach',
    features: [
      'Los 5 signos de alerta que identifican una crisis en los primeros 60 segundos',
      'Protocolo Rojo: cómo intervenir en pánico agudo (5-10 minutos)',
      'Protocolo Azul: manejo de angustia profunda y duelo (15-20 minutos)',
      'Protocolo Negro: control de descontrol y brotes de rabia (5-10 minutos)',
      'El código de los 60 segundos: lectura de lenguaje corporal en crisis',
      'Sistema de goteo acelerado: dosificación correcta en emergencias',
      'Qué decir (y qué NO decir) al paciente en cada momento',
      'Casos de estudio reales: protocolo paso a paso',
      '50 páginas de contenido tácticamente organizado',
    ],
  },
  {
    label: 'TOMO II',
    title: 'Las 15 Fórmulas Maestras “Copy-Paste”',
    subtitle: 'El recetario exacto: cada fórmula lista para aplicar',
    cover: 'https://cdn.magicpatterns.com/uploads/dAjsQA7ouLBBMXBniKYv9F/pasted-image.png',
    coverAlt: 'Portada del Tomo II: Las 15 Fórmulas Maestras, Botiquín Bach',
    features: [
      'Fórmulas #1-5: las 5 de emergencia inmediata (pánico, angustia, descontrol, disociación, shock)',
      'Fórmulas #6-10: combinaciones tácticas para crisis complejas',
      'Fórmulas #11-15: cierres, protección y recuperación del terapeuta',
      'Cada fórmula incluye composición exacta, método, frecuencia, duración y señales de éxito',
      'Variantes por intensidad de crisis (leve, moderada, severa)',
      'Método del vaso de agua: la técnica que acelera la absorción 3x',
      'Combinación tópica + oral: protocolo ultra-potente para crisis severas',
      '50 páginas de recetas precisas, sin teoría innecesaria',
    ],
  },
];

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Placa Visual de Emergencia',
    pages: '10 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/aSr6R8SCwN4xAGnPYkwWsS/pasted-image.png',
  },
  {
    number: '02',
    title: 'Guía de Bach Tópico',
    pages: '15 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/jS18gsN2p83P7EmsYV8qNt/pasted-image.png',
  },
  {
    number: '03',
    title: 'Ficha de Registro de Crisis',
    pages: '15 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/aW3Qamkb3jvsAuEuEWzpC4/pasted-image.png',
  },
  {
    number: '04',
    title: 'El Escudo del Terapeuta',
    pages: '20 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/x2gLehzS7CMLaMHLJMX1MH/pasted-image.png',
  },
  {
    number: '05',
    title: 'Masterclass: El Negocio',
    pages: '20 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/43MxLdZiHPaapVGezkeQtu/pasted-image.png',
  },
];
